import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

import { ApiService } from './api.service';
import { MessageService } from './message.service';
import { InfoRegistroModel } from '@models/info-registro.model';
import { OrigemLancamento } from '../models/enums/origem-lancamento';

@Injectable({
  providedIn: 'root'
})
export class LancamentoApiService extends ApiService {

  constructor(
    public override http: HttpClient,
    private messageService: MessageService
  ) {
    super(http);
  }

  public editarObservacao(lancamento: InfoRegistroModel, lancamentoEhBanco: boolean): Observable<void> {
    let origemStr = '';
    if (lancamentoEhBanco)
      origemStr = 'lancamento-banco';
    else
      origemStr = 'lancamento-caixa';
    return this.put<void>(`/${origemStr}/editar-observacao`, null, lancamento);
  }
}
